<div class="{{ navbarClass }}" [class.is-sticky]="isSticky">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light rayalina-nav">
            <a class="navbar-brand" routerLink="/" aria-label="Rayalina">
                <span class="logo-lockup">
                    <img
                        src="assets/img/rayalina-logo-shape.png"
                        width="40"
                        height="40"
                        alt=""
                        class="logo-shape"
                        decoding="async"
                    />
                    <img
                        src="assets/img/rayalina-logo-text.png"
                        height="28"
                        alt="Rayalina"
                        class="logo-text"
                        decoding="async"
                    />
                </span>
            </a>

            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Ouvrir le menu"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mx-auto">
                    <li class="nav-item"><a routerLink="/" fragment="home" class="nav-link">Accueil</a></li>
                    <li class="nav-item"><a routerLink="/" fragment="solution" class="nav-link">Solution</a></li>
                    <li class="nav-item"><a routerLink="/" fragment="features" class="nav-link">Fonctionnalités</a></li>
                    <li class="nav-item"><a routerLink="/" fragment="pricing" class="nav-link">Tarifs</a></li>
                    <li class="nav-item"><a routerLink="/contact" class="nav-link">Contact</a></li>
                </ul>
                <div class="others-options">
                    <a routerLink="/" fragment="pricing" class="nav-cta">Démarrer l'essai gratuit</a>
                </div>
            </div>
        </nav>
    </div>
</div>
